import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';

import { useComponentDidMount } from '../../hooks';
import { SelectInput, MultiSelectInput } from '../forms';
import { SchedulerReferenceStore, schedulerReferenceActions } from '../../../scheduler/store/schedulerReferenceStore';

type ServicePostSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    schedulerReferenceStore?: SchedulerReferenceStore,
    officePostId?: string, // если параметр не передан, то Включаем disable на компонент
    multiSelect?: boolean,
  };

const ServicePostSelector = (props: ServicePostSelectorProps) => {
  const {
    schedulerReferenceStore,
    officePostId,
    multiSelect,
    ...rest
  } = props;

  const { servicePostsForSelector, getServicePostForSelectorByRequest } = schedulerReferenceStore;

  const [loading, setLoading] = useState(false);

  const loadData = () => {
    if (officePostId) {
      if (getServicePostForSelectorByRequest?.officePostId !== officePostId) {
        setLoading(true);
        schedulerReferenceActions.getServicePostsForSelector({ officePostId })
          .finally(() => setLoading(false));
      }
    } else {
      schedulerReferenceActions.clearServicePostsForSelector();
    }
  };

  useComponentDidMount(() => {
    loadData();
  });

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officePostId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ servicePostsForSelector }
          dataTitle='serviceName'
          dataValue='id'
          loading={ loading }
          disabled={ rest.disabled || (!officePostId) }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ servicePostsForSelector }
          dataTitle='serviceName'
          dataValue='id'
          loading={ loading }
          disabled={ rest.disabled || (!officePostId) }
          sort
        />
      )

  );
};

export default inject('schedulerReferenceStore')(observer(ServicePostSelector));
